/**
 * Backend Authentication Service
 * Handles backend-specific authentication operations
 */

import { apiClient } from './api.client';
import { GoogleUser } from '../types/api.types';

/**
 * Validate Google token with backend
 */
export const validateGoogleToken = async (token: string): Promise<GoogleUser> => {
  return apiClient.post<GoogleUser>(
    '/api/auth/validate-google-token',
    { token },
    { skipAuth: true } // This endpoint doesn't require auth header
  );
};

